export default "__VITE_ASSET__CH_s3NXK__"